export default "__VITE_ASSET__CLgwmCWv__"